import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SubmitHandler } from "react-hook-form";
import Page from "src/layouts/Page";
import { ConfirmationModal } from "src/modals/ConfirmationModal/ConfirmationModal";
import QuickLinkForm, {
	QuickLinkFormValues
} from "../../components/QuickLinkForm/QuickLinkForm";
import useQuickLink from "../../hooks/useQuickLink";
import useEditQuickLink from "../../hooks/useEditQuickLink";
import useDeleteQuickLink from "../../hooks/useDeleteQuickLink";
import { adaptEditQuickLinkPayload } from "../../adapters/adaptQuickLinkPayload";
import { formValuesToQuickLink } from "../../adapters/formValuesToQuickLink";

function quickLinkToFormValues(link: QuickLink): QuickLinkFormValues {
	return {
		heading: link.heading,
		content: link.content ?? "",
		buttonLink: link.buttonLink ?? "",
		webview: link.webview
	};
}

const EditQuickLink = () => {
	const navigate = useNavigate();
	const { quickLinkId } = useParams<{ quickLinkId: string }>();
	const id = Number(quickLinkId);

	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [defaultValues, setDefaultValues] = useState<QuickLinkFormValues>({
		heading: "",
		content: "",
		buttonLink: "",
		webview: true
	});

	const { data: quickLink } = useQuickLink(id);
	const { mutate: editQuickLink, isLoading: isEditing } = useEditQuickLink();
	const { mutate: deleteQuickLink, isLoading: isDeleting } =
		useDeleteQuickLink();

	useEffect(() => {
		if (quickLink) {
			setDefaultValues(quickLinkToFormValues(quickLink));
		}
	}, [quickLink]);

	const handleSubmit: SubmitHandler<QuickLinkFormValues> = (data) => {
		const payload = adaptEditQuickLinkPayload(formValuesToQuickLink(data, id));

		editQuickLink(payload, {
			onSuccess: () => navigate("/app/homepage/quick-links")
		});
	};

	const handleDelete = () => {
		deleteQuickLink(id, {
			onSuccess: () => navigate("/app/homepage/quick-links")
		});
	};

	return (
		<Page>
			<QuickLinkForm
				defaultValues={defaultValues}
				onSubmit={handleSubmit}
				isSubmitting={isEditing}
				isEdit
				onDelete={() => setShowDeleteModal(true)}
			/>

			<ConfirmationModal
				isOpen={showDeleteModal}
				title="Delete quick link?"
				description="This action cannot be undone."
				onCancel={() => setShowDeleteModal(false)}
				onSubmit={handleDelete}
				submitBtnProps={{ isLoading: isDeleting }}
			/>
		</Page>
	);
};

export default EditQuickLink;
